import React, { useEffect, useState } from 'react';
import { Select } from '@/view/components/ui/select';

interface CustomSelectProps {
  onValueChange: (value: string) => void;
  defaultValue?: string;
  children: React.ReactNode;
}

export const CustomSelect = ({ onValueChange, defaultValue = "", children }: CustomSelectProps) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (newValue: string) => {
    setValue(newValue);
    if (onValueChange) {
      onValueChange(newValue);
    }
  };

  return (
    <Select onValueChange={handleChange} value={value}>
      {children}
    </Select>
  );
};
